const dashboardLang = {
  pageTitle: 'Tableau de bord',
  noAccesData: 'Vous n\'avez pas l\'autorisation pour afficher les données',
  months: {
    1: 'Janvier',
    2: 'Février',
    3: 'Mars',
    4: 'Avril',
    5: 'Mai',
    6: 'Juin',
    7: 'Juillet',
    8: 'Août',
    9: 'Septembre',
    10: 'Octobre',
    11: 'Novembre',
    12: 'Décembre'
  },

  dashboard: {
    addTitle: 'Création d\'un tableau de bord',
    editTitle: 'Modification du tableau de bord',
    edit: 'Modifier le tableau de bord',
    out: 'Sortir du mode édition',
    delete: 'Supprimer le tableau de bord',
    askDelete: 'Êtes-vous sûr de vouloir supprimer ce tableau de bord ?',
    name: 'Nom du tableau de bord',
    empty: 'Vous n\'avez aucun tableau de bord',
    create: 'Créer un tableau de bord',
    add: 'Ajouter un tableau de bord',
    allCommercials: 'Tous les commerciaux'
  },
  forecast: {
    manage: 'Gérer les prévisionnels',
    name: 'Nom du prévisionnel',
    begin: 'Année de début :',
    end: 'Année de fin :',
    createTitle: 'Création d\'un prévisionnel',
    updateTitle: 'Modification d\'un prévisionnel',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce prévisionnel ?',
    list: {
      name: 'Nom',
      begin: 'Année début',
      end: 'Année fin'
    }
  },
  widget: {
    add: 'Ajouter un widget',
    currentYear: 'Année en cours',
    currentMonth: 'Mois en cours',
    currentWeek: 'Semaine en cours',
    currentDay: 'Journée en cours',
    lastMonths: ' derniers mois',
    lastWeeks: ' dernières semaines',
    lastDays: ' derniers jours',
    edit: 'Modifier le widget',
    delete: 'Supprimer le widget',
    commercialIndicator: 'Un filtre par commercial est activé sur ce widget :',
    periodIndicator: 'Un filtre par période est appliqué sur ce widget :',
    unknown: 'Inconnu',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce widget ?',
    noDatas: 'Aucune donnée à afficher',
    addTitle: 'Ajout d\'un widget',
    editTitle: 'Modification du widget'
  }
}

export default {
  dashboard: dashboardLang
}
